import { render, staticRenderFns } from "./indie.vue?vue&type=template&id=135a680b"
import script from "./indie.vue?vue&type=script&lang=js"
export * from "./indie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SearchPage: require('/usr/src/app/components/search/page.vue').default,EducatorPanel: require('/usr/src/app/components/educator/panel.vue').default})
